import '../stylesheets/boats.css';

import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

import { getMyBoats, selectBoat } from '../actions/boats';
import boat_active from '../assets/maintain_bookings_screen/boat_active.png';
import boat_inactive from '../assets/maintain_bookings_screen/boat_inactive.png';
import EditBoatModal from '../components/EditBoatModal';

const isSelectedBoat = (value) => {
  return value === true;
};

class Boats extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      boats: [],
      selecting_boat_id: null,
    };
  }

  componentDidMount() {
    this.loadBoats();
  }

  loadBoats = () => {
    getMyBoats(
      (boats) => {
        this.setState({ boats: boats || [] });
      },
      () => {},
    );
  };

  handleSelectBoat = (boat_id) => {
    this.setState({ selecting_boat_id: boat_id }, () => {
      selectBoat(
        boat_id,
        () => {
          this.setState({ selecting_boat_id: null }, this.loadBoats);
        },
        () => {
          this.setState({ selecting_boat_id: null });
        },
      );
    });
  };

  render() {
    const { t } = this.props;
    const { headerPaddings = {} } = this.props;
    const headerPaddingStyle = {
      paddingTop: headerPaddings.top || 0,
      paddingRight: headerPaddings.right || 0,
      paddingBottom: headerPaddings.bottom || 0,
      paddingLeft: headerPaddings.left || 0,
    };

    const boatItems = this.state.boats.map((boat) => ({
      value: boat.id,
      label: boat.name || '-',
    }));
    const toValue = (value) => (value == null || value === '' ? '-' : value);

    return (
      <div className='boats'>
        <Container>
          <EditBoatModal
            onRef={(ref) => {
              this.editBoatModal = ref;
            }}
            onClose={this.loadBoats}
            contact_id={null}
          />
          <div className='boats__header' style={headerPaddingStyle}>
            <h4 className='boats__title'>{t('Booking.my_boats', 'My boats')}</h4>
          </div>
          <Row>
            <Col md={12}>
              {boatItems.length === 0 ? (
                <div className='boats__empty'>{t('Booking.no_boats', 'No boats')}</div>
              ) : (
                <div className='boats__list'>
                  {this.state.boats.map((boat, index) => (
                    <div
                      key={boat.id || index}
                      className={`boats__item ${
                        isSelectedBoat(boat.selected)
                          ? 'boats__item--selected'
                          : ''
                      }`}>
                      <div className='boats__item-header'>
                        <div className='boats__item-summary'>
                          <img
                            src={
                              isSelectedBoat(boat.selected)
                                ? boat_active
                                : boat_inactive
                            }
                            alt={t('Booking.my_boats', 'Boat icon')}
                            className='boats__item-icon'
                          />
                          <div className='boats__item-title'>
                            {boatItems[index]?.label}
                          </div>
                        </div>
                        <div className='boats__registration-badge'>
                          {toValue(boat.registration_number)}
                        </div>
                        <div className='boats__actions'>
                          {isSelectedBoat(boat.selected) ? (
                            <span className='boats__selected-badge'>
                              {t('Boats.selected', 'Selected')}
                            </span>
                          ) : (
                            <Button
                              type='button'
                              variant='outline-secondary'
                              size='sm'
                              disabled={this.state.selecting_boat_id === boat.id}
                              onClick={() => this.handleSelectBoat(boat.id)}>
                              {this.state.selecting_boat_id === boat.id
                                ? t('global.loading', 'Loading')
                                : t('Boats.select_default', 'Set as default')}
                            </Button>
                          )}
                          <Button
                            type='button'
                            variant='outline-primary'
                            size='sm'
                            onClick={() => {
                              this.editBoatModal.show(boat);
                            }}>
                            {t('global.edit', 'Edit')}
                          </Button>
                        </div>
                      </div>
                      <div className='boats__details-grid'>
                        <div className='boats__line'>
                          <span className='boats__line-label'>
                            {t('MaintainTimesAndPrices.boatDimensions', 'Boat dimensions')}
                          </span>
                          <span className='boats__line-value'>
                            {toValue(boat.length)}m / {toValue(boat.beam)}m / {toValue(boat.draft)}m
                          </span>
                        </div>
                        <div className='boats__line'>
                          <span className='boats__line-label'>
                            {t('EditBoatModal.make', 'Make')}
                          </span>
                          <span className='boats__line-value'>{toValue(boat.make)}</span>
                        </div>
                        <div className='boats__line'>
                          <span className='boats__line-label'>
                            {t('EditBoatModal.type', 'Type')}
                          </span>
                          <span className='boats__line-value'>
                            {toValue(boat.type_name || boat.type)}
                          </span>
                        </div>
                        <div className='boats__line'>
                          <span className='boats__line-label'>
                            {t('EditBoatModal.country', 'Country')}
                          </span>
                          <span className='boats__line-value'>{toValue(boat.country)}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </Col>
          </Row>
          <Row className='boats__footer'>
            <Col md={12}>
              <Button
                type='button'
                variant='primary'
                size='sm'
                onClick={() => {
                  this.editBoatModal.show();
                }}>
                {t('Booking.add_new', 'Add new')}
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(Boats);
